import React from "react";
import NetsuritLandingPage from "./NetsuritLandingPage";

function App() {
  return <NetsuritLandingPage />;
}

export default App; 